import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  deleteCourse,
  getAllCourses,
} from '../../../redux/actions/elearningActions';
import Modal from '../../../components/modal';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  submit: (fields: any) => Promise<boolean>;
  course: any;
};

const EditCourseModal = (props: Props) => {
  const { submit, open, setOpen, course } = props;
  const [title, setTitle] = useState(course?.title);
  const [description, setDescription] = useState(course?.description);
  const [file, setFile] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleFormSubmit = async () => {
    let fields;
    if (course) {
      fields = { _id: course?._id, title, description, file };
    } else {
      fields = { title, description, file };
    }
    await submit(fields);
    setOpen(false);
    return true;
  };

  const setBannerImage = (e: any) => {
    setFile(e.target.files[0]);
  };

  const deleteCourseHandler = async () => {
    if (course) {
      await dispatch(deleteCourse(course._id));
      await dispatch(getAllCourses());
      setOpen(false);
    }
  };

  return (
    <Modal
      isOpen={open}
      setOpen={setOpen}
      showCancel={true}
      title={t('courses.add_or_edit_course')}
      onConfirm={handleFormSubmit}
    >
      <form>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            {t('courses.course_title')}
          </label>
          <input
            id="coursetitle"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder={t('courses.course_title')}
            required
            onChange={(e) => setTitle(e.target.value)}
            value={title}
          />
        </div>
        <div className="mb-6">
          <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
            {t('courses.description')}
          </label>
          <textarea
            id="description"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            required
            rows={8}
            value={description}
            placeholder={t('courses.describe_what_course_is_about')}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
          {t('courses.add_photo_to_course')}
        </label>
        <input
          className="block w-full text-sm text-gray-900 border border-gray-300 rounded-md cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
          aria-describedby="user_avatar_help"
          id="user_avatar"
          type="file"
          accept="image/*"
          onChange={setBannerImage}
        />
      </form>

      {/* Delete */}
      {!!course && (
        <div className="flex justify-between gap-3">
          <div className="flex items-center">
            {!confirmDelete ? (
              <button
                className="rounded-md t"
                onClick={() => setConfirmDelete(!confirmDelete)}
              >
                {t('courses.delete_course')}
              </button>
            ) : (
              <div className="flex space-x-5">
                <button
                  className="font-semibold text-red-500 hover:text-red-700"
                  onClick={deleteCourseHandler}
                >
                  {t('yes')}
                </button>
                <button
                  className="font-semibold text-sky hover:text-sky-dark"
                  onClick={() => setConfirmDelete(!confirmDelete)}
                >
                  {t('no')}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {/* <div>
          <button
            className="px-3 py-2 bg-white rounded-md text-sky-dark hover:font-bold"
            onClick={() => setOpen(false)}
          >
            {t('courses.button_cancel')}
          </button>
          <button
            onClick={handleFormSubmit}
            className="px-3 py-2 bg-sky rounded-md hover:bg-sky-dark shadow-md hover:shadow-lg text-white hover:cursor-pointer"
          >
            {t('courses.buttom_submit')}
          </button>
        </div> */}
    </Modal>
  );
};

export default EditCourseModal;
